export default __webpack_public_path__ + "./image/24eeeb56c3ea08084163973bb03d64cb.jpg";